<template>
<div>

<!-- <span v-for="(operador, key) in getOperadores" :key="key">{{operador}}</span> -->
<!-- <p>--------------------</p> -->
<!-- <span>{{ getCallsMonitorOperador }}</span> -->

<!-- MODAL DE PAUSA DA TABELA-->
    <v-dialog v-model="dialogoPausa" width="500" v-if="permissaoPausaDespausaOperador">
    <v-card>
      <v-card-title>Escolha a pausa</v-card-title>
      <div class="mt-4 mx-4">
        <v-select label="Pausa" dense outlined v-model="dialogoPausaSelecionada" :items="pausas" />
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="dialogoPausa = false">Cancelar</v-btn>
        <v-btn color="primary" text @click="pausaOuDespausaOperador()">Concluir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
<!-- FIM MODAL DE PAUSA DA TABELA -->

<!-- MODAL DE REMOÇÃO DE FILA DA TABELA-->
    <v-dialog v-model="dialogoRemoverFila" width="500" v-if="permissaoRemoverFila">
    <v-card>
      <v-card-title>Escolha a fila</v-card-title>
      <div class="mt-4 mx-4">
        <v-select label="Fila" dense outlined v-model="dialogoRemoverFilaSelecionada" :items="filasOperador" />
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="dialogoRemoverFila = false">Cancelar</v-btn>
        <v-btn color="primary" text @click="removeFilaOperador()">Concluir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
<!-- FIM MODAL DE REMOÇÃO DE FILA DA TABELA -->

<!-- MODAL PARA OUVIR OPERADOR -->
<v-dialog v-model="dialogoOuvirOperador" width="500">
        <v-card>
          <v-card-title>Escolha o ramal</v-card-title>
          <div class="mt-4 mx-4">
            <v-autocomplete label="Ramal" dense outlined v-model="ramalSelecionado" :items="ramaisDisponiveis" />
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="dialogoOuvirOperador = false"> Cancelar </v-btn>
            <v-btn color="primary" text @click="ouvirOperador()"> Concluir </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
<!-- FIM MODAL PARA OUVIR OPERADOR -->

<!-- TABELA -->
<div v-if="!getOperadores">Não há dados para exibir</div>

<table v-else style="width:100%;" class="sombraDaTabela">
    <!-- DISPOSIÇÃO DAS CÉLULAS DA TABELA -->
    <colgroup span="6"></colgroup>
    <colgroup span="6"></colgroup>
    <colgroup span="6"></colgroup>
    <colgroup span="6"></colgroup>

    <!-- CABEÇALHO SUPERIOR -->
    <thead>

      <th v-if="temposSelecionados.length>0 && (permissaoPausaDespausaOperador || permissaoRemoverFila || permissaoDeslogarOperador || permissaoOuvirOperador)" colspan="6" scope="colgroup" class="operadorCabecalho barraLateralCabecalhoSuperior"></th>
      <th v-if="temposSelecionados.length>0 && !(permissaoPausaDespausaOperador || permissaoRemoverFila || permissaoDeslogarOperador || permissaoOuvirOperador)" colspan="5" scope="colgroup" class="operadorCabecalho barraLateralCabecalhoSuperior"></th>
      <th v-if="temposSelecionados.includes('diario') && incluiEntrada" colspan="6" scope="colgroup" class="diarioCabecalhoBorda cabecalhoSuperior">DIÁRIO</th>
      <th v-if="temposSelecionados.includes('diario') && !incluiEntrada" colspan="3" scope="colgroup" class="diarioCabecalhoBorda cabecalhoSuperior">DIÁRIO</th>
      
      <th v-if="temposSelecionados.includes('semanal') && incluiEntrada" colspan="6" scope="colgroup" class="semanalCabecalhoBorda cabecalhoSuperior">SEMANAL</th>
      <th v-if="temposSelecionados.includes('semanal') && !incluiEntrada" colspan="3" scope="colgroup" class="semanalCabecalhoBorda cabecalhoSuperior">SEMANAL</th>
      
      <th v-if="temposSelecionados.includes('mensal') && incluiEntrada" colspan="6" scope="colgroup" class="mensalCabecalhoBorda cabecalhoSuperior">MENSAL</th>
      <th v-if="temposSelecionados.includes('mensal') && !incluiEntrada" colspan="3" scope="colgroup" class="mensalCabecalhoBorda cabecalhoSuperior">MENSAL</th>

    </thead>

    <!-- CABEÇALHO INFERIOR -->
    <tr>
      <!-- Operador -->
      <th v-if="temposSelecionados.length>0" id="operadorNumeroCabecalho" class="barraLateralCabecalhoInferior" scope="col" style="padding: 15px 10px;">
        Operador</th>
      <th v-if="temposSelecionados.length>0" id="operadorRamalCabecalho" class="barraLateralCabecalhoInferior" scope="col">Ramal</th>
      <th v-if="temposSelecionados.length>0 && (permissaoPausaDespausaOperador || permissaoRemoverFila || permissaoDeslogarOperador || permissaoOuvirOperador)" id="operadorRamalCabecalho" class="barraLateralCabecalhoInferior" scope="col">Ações</th>
      <th v-if="temposSelecionados.length>0" id="operadorStatusCabecalho" class="barraLateralCabecalhoInferior" scope="colgroup" colspan="1">Status</th>
      <th v-if="temposSelecionados.length>0" id="operadorStatusCabecalho" class="barraLateralCabecalhoInferior" scope="colgroup" colspan="1"></th>
      <th v-if="temposSelecionados.length>0" id="operadorStatusCorCabecalho" class="barraLateralCabecalhoInferior" scope="colgroup" colspan="1"></th>

      <!-- Diário -->
        <th v-if="temposSelecionados.includes('diario')" id="diarioAtendidasCabecalho" class="cabecalhoInferior" scope="col">Atendidas</th>
        <th v-if="temposSelecionados.includes('diario')" id="diarioNaoAtendidasCabecalho" class="cabecalhoInferior" scope="col">Não Atendidas</th>
        <th v-if="temposSelecionados.includes('diario')" id="diarioTotalCabecalho" class="cabecalhoInferior" scope="col">Total</th>
        <th v-if="temposSelecionados.includes('diario') && incluiEntrada" id="diarioTmcCabecalho" class="cabecalhoInferior" scope="col">TMC</th>
        <th v-if="temposSelecionados.includes('diario') && incluiEntrada" id="diarioTmaCabecalho" class="cabecalhoInferior" scope="col">TMA</th>
        <th v-if="temposSelecionados.includes('diario') && incluiEntrada" id="diarioTmeCabecalho" class="cabecalhoInferior" scope="col">TME</th>
  
      <!-- Semanal -->
      <th  v-if="temposSelecionados.includes('semanal')"  id="semanalAtendidasCabecalho" class="cabecalhoInferior" scope="col">Atendidas</th>
      <th  v-if="temposSelecionados.includes('semanal')"  id="semanalNãoAtendidasCabecalho" class="cabecalhoInferior" scope="col">Não Atendidas</th>
      <th  v-if="temposSelecionados.includes('semanal')"  id="semanalTotalCabecalho" class="cabecalhoInferior" scope="col">Total</th>
      <th  v-if="temposSelecionados.includes('semanal') && incluiEntrada"  id="semanalTmcCabecalho" class="cabecalhoInferior" scope="col">TMC</th>
      <th  v-if="temposSelecionados.includes('semanal') && incluiEntrada"  id="semanalTmaCabecalho" class="cabecalhoInferior" scope="col">TMA</th>
      <th  v-if="temposSelecionados.includes('semanal') && incluiEntrada"  id="semanalTmeCabecalho" class="cabecalhoInferior" scope="col">TME</th>

      <!-- Mensal -->
      <th  v-if="temposSelecionados.includes('mensal')" id="mensalAtendidasCabecalho" class="cabecalhoInferior" scope="col">Atendidas</th>
      <th  v-if="temposSelecionados.includes('mensal')" id="mensalNãoAtendidasCabecalho" class="cabecalhoInferior" scope="col">Não Atendidas</th>
      <th  v-if="temposSelecionados.includes('mensal')" id="mensalTotalCabecalho" class="cabecalhoInferior" scope="col">Total</th>
      <th  v-if="temposSelecionados.includes('mensal') && incluiEntrada" id="mensalTmcCabecalho" class="cabecalhoInferior" scope="col">TMC</th>
      <th  v-if="temposSelecionados.includes('mensal') && incluiEntrada" id="mensalTmaCabecalho" class="cabecalhoInferior" scope="col">TMA</th>
      <th  v-if="temposSelecionados.includes('mensal') && incluiEntrada" id="mensalTmeCabecalho" class="cabecalhoInferior" scope="col">TME</th>
    </tr>
    
    <!-- OPERADORES -->
    
    <tr class="operador" v-for="(operador, key) in getOperadores" :key="key">
      
      <!-- Geral -->
      <!-- O padding do primeiro elemento define a altura da linha -->
      <td v-if="temposSelecionados.length>0" class="nomeENumeroDoOperador tooltip" style="padding: 15px 10px;">{{ nomeENumeroDoOperador(operador.agent) }} <span v-if="exibeOuOcultaTooltipDoNome(operador.agent)" class="tooltiptext"><i><b>{{ nomeDoOperador(operador.agent) }}</b></i></span></td>
      <td v-if="temposSelecionados.length>0" class="ramal">{{ numeroDoRamal(operador) }}</td>

      <!-- Ações -->
      <td 
        v-if="temposSelecionados.length>0 &&     
        permissaoPausaDespausaOperador ||
        permissaoRemoverFila ||
        permissaoDeslogarOperador ||
        permissaoOuvirOperador"
        class="acoes">

        <!-- Ação Ouvir Operador -->
        <span
          v-if="permissaoOuvirOperador"
          v-show="typeof operador.channels !== 'undefined' && verificaLigacoes(operador.channels) > 0"
          class="mdi mdi-volume-high acoes-icone acao-ouvir tooltip-acoes"
          @click="abreDialogOuvirOperador(operador.channels, operador.callIndex)"
        >
        <span class="tooltiptext tooltiptext-acao-ouvir"><i><b>Ouvir</b></i></span>
        </span>

        <!-- Ação Remover Fila -->
        <span
          v-if="permissaoRemoverFila"
          class="mdi mdi-close acoes-icone tooltip-acoes"
          @click="abreDialogRemoverFila(operador)"
        >
        <span class="tooltiptext-acao-remover-fila"><i><b>Remover Fila</b></i></span>
        </span>

        <!-- Ação Pausa/Despausa -->
        
        <span
          v-if="permissaoPausaDespausaOperador"
          class="mdi acoes-icone tooltip-acoes" :class="operador.paused === '0' ? 'mdi-pause' : 'mdi-play'"
          @click="operador.paused === '0' ? abreDialogPausa(operador) : pausaOuDespausaOperador(operador)"
        >
        <span class="tooltiptext-acao-pausa-despausa"><i><b>{{operador.paused === '0' ? 'Pausa' : 'Despausa'}}</b></i></span>
        </span>

        <!-- Ação Logout -->
        <span
          v-if="permissaoDeslogarOperador"
          class="tooltip-acoes">
          <span
            class="material-icons acoes-icone icone-logout"
            @click="logoutOperador(operador)"
          >
            logout
          </span>
          <span class="tooltiptext-acao-logout"><i><b>Logout</b></i></span>
        </span>


      </td>
      <!-- Fim Ações -->

      <td v-if="temposSelecionados.length>0" class="status tooltip" scope="col">
      <!--    <div class="pause-or-calls-card-monitor"> -->
                <span v-if="exibeOuOcultaTooltipDaPausa(operador.reason)" class="tooltiptext"><i><b>{{ nomeDaPausa(operador.reason) }}</b></i></span>
                <span v-show="operador.paused == '1'">{{pausa(operador)}}</span>
                <br v-show="operador.paused == '1'" />

                <span
                  @click="prevCall(operador.deviceId)"
                  v-show="typeof operador.channels !== 'undefined' && verificaLigacoes(operador.channels) > 1"
                  class="mdi mdi-chevron-left seta-ligacao"
                >
                </span>

                <span v-show="typeof operador.channels !== 'undefined' && verificaLigacoes(operador.channels) > 0">{{ numeroDaLigacao(operador) }}</span> 

                <span
                  @click="nextCall(operador.deviceId)"
                  v-show="typeof operador.channels !== 'undefined' && verificaLigacoes(operador.channels) > 1"
                  class="mdi mdi-chevron-right seta-ligacao"
                >
                </span>
                <br v-show="typeof operador.channels !== 'undefined' && verificaLigacoes(operador.channels) > 0"/>
                <span>{{tempo(operador)}}</span>
      <!-- </div> -->

      </td> 

      <td class="status" scope="col">        
        
        <!-- Indicador de ligação -->
        <span class="mdi icone-chamada" :class="indicadorDeLigacaoDeEntradaOuSaida(operador)"></span>

        <!-- Quantidade de ligações simultâneas -->
        <span v-if="typeof operador.channels !== 'undefined' && verificaLigacoes(operador.channels) > 0">  {{verificaLigacoes(operador.channels)}} </span> 
  
      </td>

      <td v-if="temposSelecionados.length>0" class="statusCor" scope="col"><span :class="`${corDoStatus(operador)}`"></span></td>

      <!-- Diário -->
      <td v-if="temposSelecionados.includes('diario')" class="diarioAtendidas diarioOperadorFundo">
        <span v-if="incluiEntrada"><strong>E: </strong>  {{ diarioAtendidasEntrada(operador) }}  <br/></span>
        <span v-if="incluiSaida"><strong>S: </strong>  {{ diarioAtendidasSaida(operador) }} {{ diarioAtendidasPorcentagem(operador) }} </span>
      </td>
      <td v-if="temposSelecionados.includes('diario')" class="diarioNaoAtendidas diarioOperadorFundo">
        <span v-if="incluiEntrada"><strong>E: </strong>  {{ diarioNaoAtendidasEntrada(operador) }}  <br/></span>
        <span v-if="incluiSaida"><strong>S: </strong>  {{ diarioNaoAtendidasSaida(operador) }} </span>
      </td>
      <td v-if="temposSelecionados.includes('diario')" class="diarioTotal diarioOperadorFundo">
        <span v-if="incluiEntrada"><strong>E: </strong>  {{ diarioTotalEntrada(operador) }}  <br/></span>
        <span v-if="incluiSaida"><strong>S: </strong>  {{ diarioTotalSaida(operador) }} </span>
      </td>
      <td v-if="temposSelecionados.includes('diario') && incluiEntrada" class="diarioTmc diarioOperadorFundo"> {{ diarioTmc(operador) }} </td>
      <td v-if="temposSelecionados.includes('diario') && incluiEntrada" class="diarioTma diarioOperadorFundo"> {{ diarioTma(operador) }} </td>
      <td v-if="temposSelecionados.includes('diario') && incluiEntrada" class="diarioTme diarioOperadorFundo"> {{ diarioTme(operador) }} </td>

      <!-- Semanal -->
      <td v-if="temposSelecionados.includes('semanal')" class="semanalAtendidas semanalOperadorFundo">
        <span v-if="incluiEntrada"><strong>E: </strong>  {{ semanalAtendidasEntrada(operador) }}  <br/></span>
        <span v-if="incluiSaida"><strong>S: </strong>  {{ semanalAtendidasSaida(operador) }} {{ semanalAtendidasPorcentagem(operador) }} </span>
      </td>
      <td v-if="temposSelecionados.includes('semanal')" class="semanalNaoAtendidas semanalOperadorFundo">
        <span v-if="incluiEntrada"><strong>E: </strong>  {{ semanalNaoAtendidasEntrada(operador) }}  <br/></span>
        <span v-if="incluiSaida"><strong>S: </strong>  {{ semanalNaoAtendidasSaida(operador) }} </span>
      </td>
      <td v-if="temposSelecionados.includes('semanal')" class="semanalTotal semanalOperadorFundo">
        <span v-if="incluiEntrada"><strong>E: </strong>  {{ semanalTotalEntrada(operador) }}  <br/></span>
        <span v-if="incluiSaida"><strong>S: </strong>  {{ semanalTotalSaida(operador) }} </span>
      </td>
      <td v-if="temposSelecionados.includes('semanal') && incluiEntrada" class="semanalTmc semanalOperadorFundo"> {{ semanalTmc(operador) }} </td>
      <td v-if="temposSelecionados.includes('semanal') && incluiEntrada" class="semanalTma semanalOperadorFundo"> {{ semanalTma(operador) }} </td>
      <td v-if="temposSelecionados.includes('semanal') && incluiEntrada" class="semanalTme semanalOperadorFundo"> {{ semanalTme(operador) }} </td>

      <!-- Mensal -->
      <td v-if="temposSelecionados.includes('mensal')" class="mensalAtendidas mensalOperadorFundo">
        <span v-if="incluiEntrada"><strong>E: </strong>  {{ mensalAtendidasEntrada(operador) }}  <br/></span>
        <span v-if="incluiSaida"><strong>S: </strong>  {{ mensalAtendidasSaida(operador) }} {{ mensalAtendidasPorcentagem(operador) }} </span>
      </td>
      <td v-if="temposSelecionados.includes('mensal')" class="mensalNaoAtendidas mensalOperadorFundo">
        <span v-if="incluiEntrada"><strong>E: </strong>  {{ mensalNaoAtendidasEntrada(operador) }}  <br/></span>
        <span v-if="incluiSaida"><strong>S: </strong>  {{ mensalNaoAtendidasSaida(operador) }} </span>
      </td>
      <td v-if="temposSelecionados.includes('mensal')" class="mensalTotal mensalOperadorFundo">
        <span v-if="incluiEntrada"><strong>E: </strong>  {{ mensalTotalEntrada(operador) }}  <br/></span>
        <span v-if="incluiSaida"><strong>S: </strong>  {{ mensalTotalSaida(operador) }} </span>
      </td>
      <td v-if="temposSelecionados.includes('mensal') && incluiEntrada" class="mensalTmc mensalOperadorFundo"> {{ mensalTmc(operador) }} </td>
      <td v-if="temposSelecionados.includes('mensal') && incluiEntrada" class="mensalTma mensalOperadorFundo"> {{ mensalTma(operador) }} </td>
      <td v-if="temposSelecionados.includes('mensal') && incluiEntrada" class="mensalTme mensalOperadorFundo"> {{ mensalTme(operador) }} </td>

    </tr>
  </table>
  <!-- FIM TABELA -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { monitorOperadorMethods } from '../_utils/monitorOperadorMethods'

import { obtainUserPermissions } from '@/utils/obtainUserPermissions'
import {
  arrayPermissaoPausaDespausaOperador,
  arrayPermissaoRemoverFila,
  arrayPermissaoDeslogarOperador,
  arrayPermissaoOuvirOperador,
} from '../_utils/arraysPermissionsMonitorOperador'

export default {
  name: 'TabelaMonitorOperador',
  props:[ 'temposSelecionados', 'incluiEntrada', 'incluiSaida', 'incluiIndisponiveis','operadoresOuDepartamentosSelecionados' ],
  
  data: () => ({
    //Geral
    operadores: [],
    pausas: [],
    operadorSelecionado: '',
    
    //Dialogo Pausa
    dialogoPausa: false,
    dialogoPausaSelecionada: '',
    
    //Dialogo Remoção de Fila
    filas: [],
    filasOperador: [],
    dialogoRemoverFila: false,
    dialogoRemoverFilaSelecionada: '',

    //Dialogo Ouvir Operador
    dialogoOuvirOperador: false,
    ramaisDisponiveis: [],
    ramalSelecionado: '',
    channelOuvido: '',

    //Permissões
    permissaoPausaDespausaOperador: false,
    permissaoRemoverFila: false,
    permissaoDeslogarOperador: false,
    permissaoOuvirOperador: false,
    }),

  async created() {

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissionLocalStorage => {
      if (arrayPermissaoPausaDespausaOperador.includes(permissionLocalStorage)) {
        this.permissaoPausaDespausaOperador = true
      }
      if (arrayPermissaoRemoverFila.includes(permissionLocalStorage)) {
        this.permissaoRemoverFila = true
      }
      if (arrayPermissaoDeslogarOperador.includes(permissionLocalStorage)) {
        this.permissaoDeslogarOperador = true
      }
      if (arrayPermissaoOuvirOperador.includes(permissionLocalStorage)) {
        this.permissaoOuvirOperador = true
      }
    })

    await Promise.all([this.listarPausas()])
    this.pausas = this.getPausas.map(pausa => ({ text: pausa.description, value: pausa._id }))
    if(this.pausas.length > 0){
      this.pausas = this.pausas.filter(( pausa ) => pausa.text !== 'autopause' );
    }

    await Promise.all([this.listarFilas()])
    this.filas = this.getFilas.map(fila => ({ text: fila.description, value: fila._id }))

    this.ramaisDisponiveis = this.getRamais.map(ramal => ({ text: ramal.deviceId, value: ramal.deviceId }))

  },

  computed: {
  ...mapGetters(['getRamais', 'getCallsMonitorOperador']),
  ...mapGetters('monitorOperadorStoreDados', ['getDepartamentos', 'getOperadores', 'getFilas', 'getPausas']),

    getDepartamentos(){
      return ''
    },
      
    getOperadores() {
      let operadores = []
      
      if (this.getRamais) {
        this.getRamais.forEach(ramal => {
          if (this.incluiIndisponiveis == false) {
            // Quando o checkbox de Indisponiveis não está selecionado, só mostra os operadores que estão disponíveis
            if (ramal.agent != null && ramal.isNotRegistered == false) {
              this.operadoresOuDepartamentosSelecionados.forEach(operador => {
                if (operador == ramal.agent) {
                  operadores.push(ramal)
                }
              })
            }
          }
          else if (this.incluiIndisponiveis == true) {
            // Quando o checkbox de Indisponiveis está selecionado, mostra todos os operadores
            if (ramal.agent != null) {
              this.operadoresOuDepartamentosSelecionados.forEach(operador => {
                if (operador == ramal.agent) {
                      operadores.push(ramal)
                    }
                  })
                }
              }
            })
      return operadores
      } else {
        return operadores
      }
    },
  },

  methods: {
    ...mapActions(['prevCall', 'nextCall']),
    ...mapActions('monitorOperadorStoreDados', ['listarFilas', 'listarPausas']),
    ...obtainUserPermissions,
    ...monitorOperadorMethods,

  }
}
</script>

<style scoped>
/*     
  - Geral
  - Tabela
  - Cabeçalho
  - Linhas
  - Barra lateral 
*/


  /* ====== 
    GERAL 
    =======*/

  body {
    font-family: 'Roboto', sans-serif;
  }

  /* TABELA */

  table {
    border-collapse: separate;
    border-spacing: 0;
    margin: 0 auto;
  }
  .sombraDaTabela{
    box-shadow: 0px 3px 6px #00000029;
    }

  .thead {
    box-shadow: 0px 3px 6px #00000029;
    position: sticky;
    top: 45;
    z-index: 2;
    display: inline;
  }

  th,
  td {
    white-space: nowrap;
    padding: 9px 9px;
  }

  th {
    box-sizing: border-box;
    padding: 11px 9px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    background: white;
  }

  td {
    border-top: 1px solid rgb(218, 218, 218);
    text-align: left;
    font-size: 13px;
    color: #212121;
    padding: 9px 9px;
    white-space: nowrap;
  }

  /* === FIM TABELA ===*/

  /* ======
  CABEÇALHO  
  ====== */

  /* DISPOSIÇÃO */

  .cabecalhoSuperior {
    background-color: white;
    position: sticky;
    top: 45px;
    position: -webkit-sticky;
    position: -moz-sticky;
    position: -ms-sticky;
    position: -o-sticky;
    z-index: 2;
  }

  .cabecalhoInferior {
    background-color: white;
    top: 85px;
    position: sticky;
    position: -webkit-sticky;
    position: -moz-sticky;
    position: -ms-sticky;
    position: -o-sticky;
    z-index: 1;
    text-align: left;

    box-shadow: 0px 1px 1px #00000029;
  }

  /* BORDAS CABEÇALHO */
  .diarioCabecalhoBorda {
    border-bottom: 4px solid #283593;
  }

  .semanalCabecalhoBorda {
    border-bottom: 4px solid #F17C3A;
  }

  .mensalCabecalhoBorda {
    border-bottom: 4px solid gray;
  }

  /* === FIM CABECALHO ===*/

  /* =======
    LINHAS 
    ======= */

  /* FUNDO DAS LINHAS */

  .diarioOperadorFundo {
    background-color: rgba(142, 156, 255, 0.057);
  }

  .semanalOperadorFundo {
    background-color: rgba(241, 125, 58, 0.057);
  }

  .mensalOperadorFundo {
    background-color: rgba(198, 198, 198, 0.057);
  }

  .operador:nth-child(odd) {
    background-color: rgba(213, 213, 213, 0.153);
  }

  .operador:nth-child(even)>.nomeENumeroDoOperador {
    background-color: white;
  }

  .operador:nth-child(even)>.ramal {
    background-color: white;
  }

  .operador:nth-child(even)>.acoes {
    background-color: white;
  }

  .operador:nth-child(even)>.status {
    background-color: white;
  }

  .operador:nth-child(even)>.statusCor {
    background-color: white;
  }

  .operador:nth-child(odd)>.ramal {
    background-color: #F9F9F9;
  }

  .operador:nth-child(odd)>.acoes {
    background-color: #F9F9F9;
  }

  .operador:nth-child(odd)>.nomeENumeroDoOperador {
    background-color: #F9F9F9;
  }

  .operador:nth-child(odd)>.status {
    background-color: #F9F9F9;
  }

  .operador:nth-child(odd)>.statusCor {
    background-color: #F9F9F9;
  }

  /* === FIM LINHAS ===*/

  /* BARRA LATERAL */
  .barraLateralCabecalhoSuperior {
    background-color: white;
    box-shadow: 0px 1px 1px #00000029;
    border-right: #00000029 solid 1px;
    /* box-shadow: 2px 0px 3px #0000001e; */
    top: 45px;
    position: sticky;
    position: -webkit-sticky;
    position: -moz-sticky;
    position: -ms-sticky;
    position: -o-sticky;

    z-index: 4;

  }

  .barraLateralCabecalhoInferior {
    background-color: white;
    text-align: left;
    top: 85px;
    position: sticky;
    position: -webkit-sticky;
    position: -moz-sticky;
    position: -ms-sticky;
    position: -o-sticky;
    z-index: 4;

    box-shadow: 0px 1px 1px #00000029;
  }

  .operadorCabecalho {
    border-bottom: 4px solid rgba(240, 240, 240, 0.153);
    background-color: #FDFDFD;
    border-right: #00000029 solid 1px;

  }

  #operadorNumeroCabecalho {
    background-color: white;
    text-align: center;
  }

  #operadorRamalCabecalho {
    background-color: white;
    text-align: center;
  }

  #operadorAcoesCabecalho {
    background-color: white;
    text-align: center;
  }

  #operadorStatusCabecalho {
    background-color: white;
    text-align: center;
  }

  #operadorStatusCorCabecalho {
    background-color: white;
    border-right: #00000029 solid 1px;
    /* border-bottom: #00000029 solid 1px; */
    /* box-shadow: 2px 0px 3px #0000001e; */
  }

  .nomeENumeroDoOperador {
    background-color: white;
    white-space: pre;
    text-align: center;
  }

  .ramal {
    background-color: white;
    text-align: center;
  }

  .acoes {
    text-align: center;
  }


  .status {
    background-color: white;
    white-space: pre;
    text-align: center;
  }

  .statusCor {
    background-color: white;
  }

  /* cores do status do operador */

  .operadorOcupado {
    background-color: #FF0000;
    padding: 20px 5px;
    border: 1px solid #28359329
  }

  .operadorDisponivel {
    background-color: #37AA04;
    padding: 20px 5px;
    border: 1px solid #2D3A996F;
  }

  .operadorEmPausa {
    background-color: #FFC400;
    padding: 20px 5px;
    border: 1px solid #2D3A9953
  }

  .operadorOffline {
    background-color: #bdbdbd;
    padding: 20px 5px;
    border: 1px solid #28359329
  }

  .operadorIniciandoOuRecebendoChamada{
    background-color: #F07C3A;
    padding: 20px 5px;
    border: 1px solid #28359329
  }

  .statusCor {
    border-right: #00000029 solid 1px;
    /* box-shadow: 2px 0px 3px #0000001e; */
  }

/* Referência de posição para o Tooltip */
.tooltip {
  position: relative;
  /* cursor: default; */
}

.tooltip-acoes {
  position: relative;
  display: inline-block;
  /* cursor: default; */
}

/* Texto do Tooltip */
.tooltip .tooltiptext {
  /* Posiciona o tooltip */
  position: absolute;
  z-index: 4;
  bottom: 85%;
  font-size: 13px;

  /* Define a aparência do Tooltip */
  display: flex;
  visibility: hidden;
  background-color: rgba(55, 55, 55, 0.5);
  color: #fff;
  text-align: center;
  padding: 5px 5px;
  border-radius: 6px;
}

/* Insere um triângulo no Tooltip */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 20%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent rgba(55, 55, 55, 0.5) transparent;
  transform: rotate(180deg);
}

/* Mostra o tooltip ao passar do mouse sobre o texto reduzido */
.tooltip:hover .tooltiptext {
  visibility: visible;
}

/* Texto do Tooltip - AÇÃO REMOVER FILA */
.tooltip-acoes .tooltiptext-acao-remover-fila {
  /* Posiciona o tooltip - AÇÃO */
  position: absolute;
  z-index: 4;
  bottom: 120%;
  font-size: 13px;

  /* Define a aparência do Tooltip - AÇÃO REMOVER FILA */
  display: flex;
  visibility: hidden;
  background-color: rgba(55, 55, 55, 0.5);
  color: #fff;
  text-align: center;
  padding: 5px 5px;
  border-radius: 6px;
}

/* Insere um triângulo no Tooltip - AÇÃO REMOVER FILA */
.tooltip-acoes .tooltiptext-acao-remover-fila::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 10%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent rgba(55, 55, 55, 0.5) transparent;
  transform: rotate(180deg);
}

/* Mostra o tooltip ao passar do mouse sobre o texto reduzido - AÇÃO REMOVER FILA */
.tooltip-acoes:hover .tooltiptext-acao-remover-fila {
  visibility: visible;
}

/* Texto do Tooltip - AÇÃO PAUSA DESPAUSA */
.tooltip-acoes .tooltiptext-acao-pausa-despausa {
  /* Posiciona o tooltip - AÇÃO PAUSA DESPAUSA */
  position: absolute;
  z-index: 4;
  bottom: 120%;
  font-size: 13px;

  /* Define a aparência do Tooltip - AÇÃO PAUSA DESPAUSA */
  display: flex;
  visibility: hidden;
  background-color: rgba(55, 55, 55, 0.5);
  color: #fff;
  text-align: center;
  padding: 5px 5px;
  border-radius: 6px;
}

/* Insere um triângulo no Tooltip - AÇÃO PAUSA DESPAUSA */
.tooltip-acoes .tooltiptext-acao-pausa-despausa::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 17%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent rgba(55, 55, 55, 0.5) transparent;
  transform: rotate(180deg);
}

/* Mostra o tooltip ao passar do mouse sobre o texto reduzido - AÇÃO PAUSA DESPAUSA */
.tooltip-acoes:hover .tooltiptext-acao-pausa-despausa {
  visibility: visible;
}

/* Texto do Tooltip - AÇÃO LOGOUT */
.tooltip-acoes .tooltiptext-acao-logout {
  /* Posiciona o tooltip - AÇÃO LOGOUT */
  position: absolute;
  z-index: 4;
  bottom: 140%;
  font-size: 13px;

  /* Define a aparência do Tooltip - AÇÃO LOGOUT */
  display: flex;
  visibility: hidden;
  background-color: rgba(55, 55, 55, 0.5);
  color: #fff;
  text-align: center;
  padding: 5px 5px;
  border-radius: 6px;
}

/* Insere um triângulo no Tooltip - AÇÃO LOGOUT */
.tooltip-acoes .tooltiptext-acao-logout::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 17%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent rgba(55, 55, 55, 0.5) transparent;
  transform: rotate(180deg);
}

/* Mostra o tooltip ao passar do mouse sobre o texto reduzido - AÇÃO LOGOUT */
.tooltip-acoes:hover .tooltiptext-acao-logout {
  visibility: visible;
}

/* Texto do Tooltip - AÇÃO OUVIR */
.tooltip-acoes .tooltiptext-acao-ouvir {
  /* Posiciona o tooltip - AÇÃO LOGOUT */
  position: absolute;
  z-index: 4;
  bottom: 120%;
  font-size: 13px;

  /* Define a aparência do Tooltip - AÇÃO LOGOUT */
  display: flex;
  visibility: hidden;
  background-color: rgba(55, 55, 55, 0.5);
  color: #fff;
  text-align: center;
  padding: 5px 5px;
  border-radius: 6px;
}

/* Insere um triângulo no Tooltip - AÇÃO OUVIR */
.tooltip-acoes .tooltiptext-acao-ouvir::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 17%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent rgba(55, 55, 55, 0.5) transparent;
  transform: rotate(180deg);
}

/* Mostra o tooltip ao passar do mouse sobre o texto reduzido - AÇÃO OUVIR */
.tooltip-acoes:hover .tooltiptext-acao-ouvir {
  visibility: visible;
}

/* Ícones das ações */

  .acoes-icone {
    font-size: 16px;
    margin-right: 3px;
    cursor: pointer;
  }

  .acao-ouvir {
    font-size: 15px;
  }

  .icone-chamada{
    font-size: 14px;
    cursor: default;
  }

  .icone-logout {
    font-size: 13px;
    margin-right: 0px;
    cursor: pointer;
  }

  /* Seta para mudar a ligacao */
  .seta-ligacao {
    font-size: 15px;
    cursor: pointer;
  }

  /* === FIM BARRA LATERAL === */

</style>
